import { InjectionToken } from "@angular/core";

export class GliApiConfiguration {
    url: string;
}

export const GLI_API_CONFIGURATION = new InjectionToken<Promise<GliApiConfiguration>>(
    "GliApiConfiguration"
);
